import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ToDo } from './interface/todo.interface';
import { TodoService } from './service/todo.service';
import { MaterialModule } from 'src/app/material.module';
import { MatTableModule } from '@angular/material/table';
import { TablerIconsModule } from 'angular-tabler-icons';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-reviews',
  templateUrl: './reviews.component.html',
  styleUrls: ['./reviews.component.scss'],
  imports: [
    MatCardModule,
    MatSidenavModule,
    CommonModule,
    MaterialModule,
    TablerIconsModule,
    MatTableModule,
    ReactiveFormsModule,
    FormsModule
  ],
  standalone: true,
})
export class ReviewsComponent {
  sidePanelOpened = true;
  public showSidebar = false;
  inputFg: UntypedFormGroup = Object.create(null);
  todoId = 6;
  copyTodos: ToDo[];
  selectedCategory = 'all';
  searchText: string | null = null;
  editSave = 'Edit';

  todos: ToDo[] = this.todoService.getTodos();

  constructor(public todoService: TodoService, public fb: UntypedFormBuilder) {
    this.copyTodos = this.todos;
  }

  isOver(): boolean {
    return window.matchMedia(`(max-width: 960px)`).matches;
  }

  mobileSidebar(): void {
    this.showSidebar = !this.showSidebar;
  }

  ngOnInit(): void {
    this.inputFg = this.fb.group({
      mess: [],
    });
  }

  addTodo(value: string): void {
    if (this.inputFg?.get('mess')?.value.trim().length === 0) {
      return;
    }
    this.todos.splice(0, 0, {
      id: this.todoId,
      message: this.inputFg?.get('mess')?.value,
      completionStatus: false,
      edit: false,
      date: new Date(),
    });
    this.copyTodos = this.todos;
    this.todoId++;
    this.inputFg.patchValue({
      mess: '',
    });
  }

  allTodos(): void {
    // tslint:disable-next-line - Disables all
    this.todos.forEach(
      (todo) =>
        (todo.completionStatus = (<HTMLInputElement>event!.target).checked)
    );
  }

  selectionlblClick(val: string): void {
    if (val === 'all') {
      this.copyTodos = this.todos;
      this.selectedCategory = 'all';
    } else if (val === 'uncomplete') {
      this.copyTodos = this.todos.filter((todo) => !todo.completionStatus);
      this.selectedCategory = 'uncomplete';
    } else if (val === 'complete') {
      this.copyTodos = this.todos.filter((x) => x.completionStatus);
      this.selectedCategory = 'complete';
    }
  }

  editTodo(i: number, str: string): void {
    if (this.copyTodos) {
      if (str === 'edit') {
        // tslint:disable-next-line - Disables all
        this.copyTodos.find((x) => x.id === i)!.edit = true;
      } else {
        // tslint:disable-next-line - Disables all
        this.copyTodos.find((x) => x.id === i)!.edit = false;
      }
    }
  }

  deleteTodo(id: number): void {
    console.log(id);
    this.todos.splice(id, 1);
  }

  remainingList(): number {
    return this.todos.filter((todo) => !todo.completionStatus).length;
  }
}
